import { Box, Card, Checkbox, type SxProps } from '@mui/material';

export const SelectableCard = ({
  selected,
  onChange,
  children,
  variant = 'vertical',
  sx,
}: {
  selected: boolean;
  onChange: () => void;
  children: React.ReactNode;
  variant?: 'vertical' | 'horizontal';
  sx?: SxProps;
}) => (
  <Card
    sx={{
      flexGrow: 1,
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: variant === 'vertical' ? 'column' : 'row',
      ...sx,
    }}
  >
    {children}
    <Box
      sx={{
        position: 'absolute',
        bottom: variant === 'vertical' ? '8px' : 'auto',
        top: variant === 'horizontal' ? '8px' : 'auto',
        right: '8px',
        zIndex: 1,
      }}
    >
      <Checkbox
        checked={selected}
        color="primary"
        size="small"
        sx={{
          '& .MuiSvgIcon-root': {
            fontSize: 24,
          },
        }}
        onChange={e => {
          e.stopPropagation();
          e.preventDefault();
          onChange();
        }}
      />
    </Box>
  </Card>
);
